module.exports = __webpack_public_path__ + "img/aDirectorForm.3001f930.jpg";